import { Injectable } from '@angular/core';
import { FlamingoHttpService } from '@flamingo/service/flamingo-http.service';
import { Observable } from 'rxjs';
import { AccountUpdate } from '../../core/model/account-update.model';
import { AccountView } from '../../core/model/account-view.model';
import { DebtorStatus } from '../../core/model/debtor-list.model';
import { SellerStatus } from '../../core/model/seller-list.model';
import { MatDialog } from '@angular/material/dialog';
import { OnboardingAlertDialogComponent } from '../../component/onboarding-alert-dialog/onboarding-alert-dialog.component';
import { tap } from 'rxjs/operators';
import { SellerAccountView } from '../../core/model/seller-account-view.model';

@Injectable({
  providedIn: 'root',
})
export class MainService {

  constructor(
    private _httpService: FlamingoHttpService,
    private _dialog: MatDialog
  ) {
  }

  private _user: AccountView;

  get user(): AccountView {
    return this._user;
  }

  set user(value: AccountView) {
    this._user = value;
  }

  public getAccount(): Observable<AccountView> {
    return this._httpService.get(`/account`).pipe(
      tap(user => {
        this.user = user;
        this.checkOnboardingAlert();
      })
    );
  }

  public updateAccount(account: AccountUpdate): Observable<AccountView> {
    return this._httpService.put(`/account`, account);
  }

  getDebtorFakeStatus(status: DebtorStatus): DebtorStatus {
    switch (status) {
      case DebtorStatus.DANGEROUS:
        return DebtorStatus.PENDING_VALIDATION;
      case DebtorStatus.APPROVED:
        return DebtorStatus.PRE_APPROVED;
      case DebtorStatus.TO_REVIEW:
        return DebtorStatus.PENDING_VALIDATION;
      default:
        return status;
    }
  }

  getSellerFakeStatus(status: SellerStatus): SellerStatus {
    switch (status) {
      case SellerStatus.SELLING:
      case SellerStatus.NOT_SELLING:
        return SellerStatus.ACTIVATED;
      case SellerStatus.DANGEROUS:
      case SellerStatus.TO_REVIEW:
        return SellerStatus.PENDING_VALIDATION;
      case SellerStatus.PENDING_ACTIVATION:
        return SellerStatus.PENDING_CONTRACT;
      default:
        return status;
    }
  }

  private checkOnboardingAlert(): void {
    const user = this.user as SellerAccountView;

    if (user && user.profileType === 'SELLER') {
      const showOnboardingButton = user.showOnboardingButton;

      if (showOnboardingButton === 1 || showOnboardingButton === 2) {
        this._dialog.open(OnboardingAlertDialogComponent, {
          width: '400px',
          disableClose: false,
          data: { user: user }
        });
      }
    }
  }

}
